import { Validators } from '@angular/forms';

export const DtoRegex = {
  pan: /^[A-Z]{5}\d{4}[A-Z]{1}$/,
  tin: /^[A-Z]{4}\d{5}[A-Z]{1}$/,
  cin: /^[A-Z]{1}\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/,
  legalName: /^[a-zA-Z0-9 ]{4,75}$/,
  personName: /^[a-zA-Z ]{3,40}$/,
  website: /^[a-z.-]{4,60}[.][a-z]{2,}$/,
  email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
  phone: /^[6-9]\d{9}$/,
  password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^?])[A-Za-z\d!@#$%^?]{8,32}$/,
};

export const required = Validators.required;
export const pan = Validators.pattern(DtoRegex.pan);
export const tin = Validators.pattern(DtoRegex.tin);
export const cin = Validators.pattern(DtoRegex.cin);
export const legalName = Validators.pattern(DtoRegex.legalName);
export const personName = Validators.pattern(DtoRegex.personName);
export const website = Validators.pattern(DtoRegex.website);
export const email = Validators.email;
export const phone = Validators.pattern(DtoRegex.phone);
export const password = Validators.pattern(DtoRegex.password);

export const alphaNumeric = (min: number, max: number) => [
  Validators.minLength(min),
  Validators.maxLength(max),
  Validators.pattern(/^[a-zA-Z0-9 ]*$/),
];

export const digits = (min: number, max: number) => [
  Validators.minLength(min),
  Validators.maxLength(max),
  Validators.pattern(/^\d+$/),
];

export const numeric = (min: number, max: number) => [
  Validators.min(min),
  Validators.max(max),
  Validators.pattern(/^\d+$/),
];
